module.exports = __webpack_public_path__ + "static/media/directions-purple-apple.634b585f.svg";